function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLockFillIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 25 24",
    style: {
      enableBackground: "new 0 0 25 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "m17 9 .1-.6c.3-2.1-.7-4.1-2.4-5.3h0c-2.1-1.4-4.8-1.2-6.7.4l-.8.7",
    style: {
      fill: "none",
      stroke: "#1c3f88",
      strokeWidth: 1.2,
      strokeLinecap: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.5 8.4h8.1c.9 0 1.6 0 2.2.1.6.1 1.1.3 1.6.7.4.4.6 1 .7 1.6.1.6.1 1.3.1 2.2v2c0 1.4 0 2.5-.1 3.3-.1.9-.4 1.6-.9 2.2-.6.6-1.3.8-2.2.9-.9.1-2 .1-3.3.1h-4.1c-1.4 0-2.5 0-3.3-.1-.9-.1-1.6-.4-2.2-.9-.7-.5-1-1.2-1.1-2.1-.1-.9-.1-2-.1-3.3V13c0-.9 0-1.6.1-2.2.1-.6.3-1.1.7-1.6.4-.4 1-.6 1.6-.7.5-.1 1.3-.1 2.2-.1zm4 8.6c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#1c3f88"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockFillIcon);
export default __webpack_public_path__ + "static/media/lock-fill-icon.e41da5d6002de2b20afd5f08702ee14c.svg";
export { ForwardRef as ReactComponent };